<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><span><a id="page_i"></a>Master of Space<br/>and Time</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?0664a484